import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import Button from '@material-ui/core/Button';



class ClubInfoModal extends Component {


    constructor(props){
        super(props);
        this.state = {
            club_number : '' 
        };
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            club_number: e.target.value
        });
    }
    handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRStore.getClubData(this.state.club_number) 
    }

    render() {
        return(
            <div> 
            Please Enter a Club ID
            <ValidatorForm
                ref="form"
                instantValidate = {false}
                onSubmit={this.handleSubmit}
                onError={errors => console.log(errors)}
            >
                <TextValidator
                    label="ClubID"
                    onChange={this.handleChange}
                    name="ClubID"
                    value={this.state.club_number}
                    validators={['required']}
                    errorMessages={['this field is required']}
                />
                <Button type="submit">Submit</Button>
                <br/>
            </ValidatorForm>
            </div>
        );
    }
}

ClubInfoModal = inject('DGRStore','DGRModalStore')(observer(ClubInfoModal))     
export default ClubInfoModal;



// WEBPACK FOOTER //
// ./src/components/DGR/Modal/ClubInfoModal.js